import { create } from "zustand"
import { overviewBundle } from "./overview-const"

export const overviewStore = create((set, get) => ({
  selectedTab: overviewBundle.tabs[0], // INFO: 오늘
  setSelectedTab: (selectedTab) => set({ selectedTab }),

  resetKeyMap: {
    rank: 0,
    trend: 0 // ! 다시 그리기 위해 리셋함.
  },
  setResetKey: (key) => {
    const { resetKeyMap } = get()
    resetKeyMap[key]++
    set({ resetKeyMap })
  },

  tabClick: (tab) => {
    const { resetKeyMap } = get()
    for (const key in resetKeyMap) {
      resetKeyMap[key]++
    }
    set({ selectedTab: tab, resetKeyMap })
  }
}))
